import { useSearchParams } from 'react-router-dom';

import { Sport } from '@sorare/core/src/__generated__/globalTypes';
import { NewPageHeader } from '@sorare/core/src/components/navigation/NewPageHeader';
import { ProfilePageHeader } from '@sorare/core/src/components/navigation/ProfilePageHeader';
import { SECONDARY_MARKET_URL_BY_SPORT } from '@sorare/core/src/constants/routes';
import { useCurrentUserContext } from '@sorare/core/src/contexts/currentUser';
import { useSportContext } from '@sorare/core/src/contexts/sport';
import { useFeatureFlags } from '@sorare/core/src/hooks/useFeatureFlags';
import { navLabels } from '@sorare/core/src/lib/glossary';

type Props = {
  showCommonCoins?: Nullable<boolean>;
};
export const MarketHeader = ({ showCommonCoins }: Props) => {
  const {
    flags: { useNewNav = false },
  } = useFeatureFlags();

  const [searchParams] = useSearchParams();
  const previousParams = searchParams.get('previousParams');

  const { currentUser } = useCurrentUserContext();

  const { sport } = useSportContext();
  const marketBaseUrl = SECONDARY_MARKET_URL_BY_SPORT[sport || Sport.FOOTBALL];
  const marketUrl =
    previousParams === null
      ? undefined
      : `${marketBaseUrl}${previousParams || ''}`;

  if (currentUser && !useNewNav) {
    return <ProfilePageHeader showCommonCoins={showCommonCoins} />;
  }
  return (
    <NewPageHeader
      text={marketUrl ? undefined : navLabels.market}
      backTo={marketUrl}
      disableBackBrowser
    />
  );
};
